import React, { useState } from "react";
import { Modal, Input, Button } from "antd";

export const FamilyDisableAccountBtn = ({ disableAccount }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    await disableAccount(reason);
    setLoading(false);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} size="small" danger>
        Disable Account
      </Button>
      <Modal
        title="Disable Account Reason"
        visible={open}
        centered
        onOk={save}
        confirmLoading={loading}
        onCancel={() => setOpen(false)}
        maskClosable={false}
        okButtonProps={{ disabled: !reason.trim() }}
      >
        <Input.TextArea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={250}
          placeholder="Enter reason for disabling account"
        />
      </Modal>
    </>
  );
};
